import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ViewFileComponent } from '@shared/components/view-file/view-file.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-attachment-renderer',
  template: `
    <div class="attachment">
      <app-button-group
        class="btn-edit"
        [label]="'View'"
        [buttonType]="'Light'"
        [buttonUseCase]="'view'"
        [icon]="'visibility'"
        [iconFillType]="'outlined'"
        [disabled]="!hasAttachment"
        (onEmit)="openAttachment()"
      ></app-button-group>
    </div>
  `,
  styles: [
    `
      .attachment {
        display: flex;
        gap: 8px;
        align-items: center;
        padding: 4px;
      }
      .attachment ::ng-deep app-button-group {
        flex-shrink: 0;
      }
      .attachment .btn-edit {
        padding-right: 10px !important;
      }
    `,
  ],
})
export class AttachmentRenderer implements ICellRendererAngularComp {
  params: any;
  hasComments: boolean = false;

  hasAttachment: boolean = false;
  attachmentUrl: string = '';

  constructor(
    private dialog: MatDialog,
    private toasterService: ToastrService,
  ) {}

  agInit(params: any): void {
    this.params = params;
    this.attachmentUrl = params.data?.fileAttachmentUrl || '';
    this.hasAttachment = !!this.attachmentUrl;
  }

  refresh(params: any): boolean {
    this.agInit(params);
    return true;
  }

  openAttachment(): MatDialogRef<ViewFileComponent> | null {
    if (!this.attachmentUrl) {
      this.toasterService.error('Order not found');
      return null;
    }
    const panelClass = 'view-file-dialog';
    const dialogConfig = {
      panelClass: panelClass,
      data: {
        file: this.attachmentUrl,
      },
    };
    return this.dialog.open(ViewFileComponent, dialogConfig);
  }
}
